/**
 * Define margins for the counts graph
 * (with axes occupying the space within the margins)
 */
export type GraphMargins = {
    top: number;
    left: number;
    right: number;
    bottom: number;
};

export enum AxisOrientation {
    TOP,
    BOTTOM,
    LEFT,
    RIGHT,
}

/**
 * Due to D3's data/join paradigm, we follow this pattern for defining a stacked bar,
 *    https://observablehq.com/@d3/stacked-bar-chart
 *
 * Stacked Value represented as a tuple
 *  [min, max, name]
 *
 *  The name is an arbitrary string to define the stack value. Typically we use a CSS class name.
 */
export type StackedValue = [number, number, string];
